module.exports = __webpack_public_path__ + "img/moma-interior.6ca29662.jpg";